<form
  [formGroup]="form"
  class="lum-page lum-page__card lum-c-assembly-order-disassembly-form"
>
  <header class="lum-page-header lum-page-header--sticky">
    <h2 class="lum-page-header__heading">
      <a [routerLink]="['/assembly-orders']">Assembly Orders</a> /
      <ng-container *ngIf="currentAssemblyOrder?.id; else new">
        Order #{{ currentAssemblyOrder.id }} (Disassembly)
      </ng-container>
      <ng-template #new>New Disassembly Order</ng-template>
    </h2>
    <div class="lum-page-header__actions">
      <label class="mb-0 d-flex align-items-baseline">
        <div class="lum-label mb-0">Status:</div>
        <mat-select class="lum-select" formControlName="status">
          <mat-option
            *ngFor="
              let orderStatus of assemblyOrderConfig.assemblyOrderStatuses;
              trackBy: trackByValue
            "
            [value]="orderStatus.value"
          >
            {{ orderStatus.label }}
          </mat-option>
        </mat-select>
      </label>
      <button
        type="button"
        class="lum-button lum-button--primary"
        [disabled]="form.invalid || loading"
        (click)="onSave()"
      >
        <ng-container *ngIf="!loading; else saveLoading">
          <lum-ui-icon
            class=""
            icon="check-circle"
            width="16"
            height="16"
          ></lum-ui-icon>
        </ng-container>
        <ng-template #saveLoading>
          <mat-progress-spinner
            class="lum-c-assembly-order-form__save__progress-spinner"
            diameter="16"
            mode="indeterminate"
          ></mat-progress-spinner>
        </ng-template>
        Save
      </button>
    </div>
  </header>

  <div class="lum-page-content">
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <ng-container *ngIf="currentAssemblyOrder === null; else selectedRfq">
            <div class="lum-label">Select SKU with BOMs</div>
            <lum-rfq-list-dropdown
              placeholder="Search SKU or Product Name"
              [rfqType]="'PRODUCT'"
              [displayValue]="this.rfqControl?.value?.productName"
              [params]="rfqParams"
              (selectOptionEvent)="onSelectRfqEvent($event)"
            ></lum-rfq-list-dropdown>
          </ng-container>
          <ng-template else #selectedRfq>
            <div class="lum-label">Product ([SKU] Name)</div>
            <div class="text-large">
              [{{ currentAssemblyOrder?.rfq?.internalSku }}]
              {{ currentAssemblyOrder?.rfq?.productName }}
            </div>
          </ng-template>
        </div>
        <div class="form-group">
          <div class="lum-label">Bill Of Materials</div>
          <ng-container *ngIf="currentAssemblyOrder === null; else selectedBom">
            <mat-select
              class="lum-select"
              formControlName="bomId"
              (selectionChange)="onSelectBomEvent($event)"
              [ngClass]="{
                error: bomIdControl?.invalid,
              }"
            >
              <mat-option
                *ngFor="let bom of boms || []; trackBy: trackById"
                [value]="bom.id"
              >
                {{ bom.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="bomIdControl && bomIdControl.invalid">
              {{ bomIdControl | validateField }}
            </mat-error>
          </ng-container>

          <ng-template else #selectedBom>
            <div class="text-large">
              {{ currentAssemblyOrder?.bom?.name }}
            </div>
          </ng-template>
        </div>
        <div class="form-group">
          <div class="lum-label">Planned Quantity</div>
          <div class="flex gap-2 text-large">
            <ng-container
              *ngIf="!loadingWarehouseGroups || !loadingLocations; else loader"
            >
              {{ plannedQuantityControl?.value || 0 | decimalPlaces }}
              {{ rfqPlannedUom?.name || '-' }} /
              {{ plannedBaseQuantityControl?.value || 0 | decimalPlaces }}
              {{ rfqActualUom?.name || '-' }}
            </ng-container>
            <ng-template #loader>
              <mat-progress-spinner
                class="progress-spinner"
                diameter="24"
                mode="indeterminate"
              ></mat-progress-spinner>
              <small>Loading...</small>
            </ng-template>
          </div>
        </div>
        <div class="d-flex gap-x-2">
          <div class="form-group">
            <div class="lum-label">Quantity</div>
            <input
              formControlName="plannedQuantity"
              class="lum-input"
              type="number"
              lumDecimalLimit
              (input)="onInputPlannedQuantityEvent($event)"
              matInput
              [ngClass]="{
                error: plannedQuantityControl?.invalid,
              }"
            />
          </div>
          <div class="form-group">
            <div class="lum-label">Unit</div>
            <mat-select
              class="lum-select"
              formControlName="uomId"
              (selectionChange)="onSelectUnitOfMeasureEvent($event)"
              [ngClass]="{
                error: uomIdControl?.invalid,
              }"
            >
              <mat-option
                *ngFor="let unit of uoms || []; trackBy: trackById"
                [value]="unit.id"
              >
                {{ unit.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="uomIdControl && uomIdControl.invalid">
              {{ uomIdControl | validateField }}
            </mat-error>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <div class="lum-label">Destination</div>
          <div class="flex gap-2 text-large">
            <ng-container *ngIf="!recomposingBomItems; else loader">
              {{ selectedWarehouseGroup?.label || '-' }} >
              {{ selectedWarehouse?.locationName || '-' }} >
              {{ selectedLocation?.location_name || '-' }}
            </ng-container>
            <ng-template #loader>
              <mat-progress-spinner
                class="progress-spinner"
                diameter="24"
                mode="indeterminate"
              ></mat-progress-spinner>
              <small>Loading...</small>
            </ng-template>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="lum-label">Warehouse Group</div>
              <mat-select
                class="lum-select"
                formControlName="warehouseGroupId"
                (selectionChange)="onSelectWarehouseGroupEvent($event)"
                [ngClass]="{
                  error: warehouseGroupIdControl?.invalid,
                }"
              >
                <mat-option
                  *ngFor="
                    let warehouseGroup of warehouseGroupsControl?.value || [];
                    trackBy: trackById
                  "
                  [value]="warehouseGroup.id"
                >
                  {{ warehouseGroup.label }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="warehouseGroupIdControl && warehouseGroupIdControl.invalid"
              >
                {{ warehouseGroupIdControl | validateField }}
              </mat-error>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="lum-label">Warehouse</div>
              <mat-select
                class="lum-select"
                formControlName="warehouseId"
                (selectionChange)="onSelectWarehouseEvent($event)"
                [ngClass]="{
                  error: warehouseIdControl?.invalid,
                }"
              >
                <mat-option
                  *ngFor="let warehouse of warehouses; trackBy: trackById"
                  [value]="warehouse.id"
                >
                  {{ warehouse.locationName }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="warehouseIdControl && warehouseIdControl.invalid">
                {{ warehouseIdControl | validateField }}
              </mat-error>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="lum-label">Location</div>
              <mat-select
                class="lum-select"
                formControlName="locationId"
                (selectionChange)="onSelectLocationEvent($event)"
                [ngClass]="{
                  error: locationIdControl?.invalid,
                }"
              >
                <mat-option
                  *ngFor="let location of mainLocations; trackBy: trackById"
                  [value]="location.id"
                >
                  {{ location.location_name }} ({{
                    location.rfq_stock_quantity || 0 | decimalPlaces
                  }})
                </mat-option>
              </mat-select>
              <mat-error *ngIf="locationIdControl && locationIdControl.invalid">
                {{ locationIdControl | validateField }}
              </mat-error>
            </div>
          </div>
          <div *ngIf="rfqControl?.value?.lotTracking || false" class="col-md-6">
            <div class="form-group">
              <div class="lum-label">Lot</div>
              <input
                matInput
                [matAutocomplete]="auto"
                class="lum-input"
                formControlName="lotId"
                placeholder="Type to search..."
                #autocompleteInput
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="displayFnLot"
                (optionSelected)="onSelectOption($event)"
              >
                <ng-container *ngIf="!loadingLots; else loaderLot">
                  <mat-option
                    *ngFor="let lot of lots; trackBy: trackById"
                    [value]="lot.id"
                  >
                    {{ lot.lotNumber }}
                  </mat-option>
                </ng-container>
                <ng-template #loaderLot>
                  <mat-option>
                    <div class="flex gap-4">
                      <mat-progress-spinner
                        class="progress-spinner mt-3"
                        diameter="24"
                        mode="indeterminate"
                      ></mat-progress-spinner>
                      <small>Loading...</small>
                    </div>
                  </mat-option>
                </ng-template>
              </mat-autocomplete>
              <mat-error *ngIf="lotIdControl && lotIdControl.invalid">
                {{ lotIdControl | validateField }}
              </mat-error>
            </div>
          </div>
        </div>

        <!-- Custom Fields Section -->
        <div class="col-12 mt-4">
          <div class="form-group">
            <div class="lum-label">Custom Fields</div>
            <div class="lum-c-assembly-order-disassembly-form__custom-fields">
              <ng-container *ngIf="!loadingCustomFields; else customFieldsLoading">
                <lum-custom-field-form-group
                  [customFieldObject]="eCustomFieldObject.DISASSEMBLY_ORDER"
                  [customFieldValues]="currentAssemblyOrder?.customFieldValues || []"
                  [formCustomFieldValues]="customFieldFormValuesJson"
                  (onChange)="onCustomFieldChange($event)"
                ></lum-custom-field-form-group>
              </ng-container>
              <ng-template #customFieldsLoading>
                <div class="form-group">
                  <mat-progress-spinner
                    class="progress-spinner"
                    diameter="24"
                    mode="indeterminate"
                  ></mat-progress-spinner>
                  <small>Loading custom fields...</small>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <ng-container *ngIf="!loadingBomItems && !loadingLots; else loaderLots">
        <lum-assembly-order-disassembly-form-table
          *ngIf="bomItems.length > 0"
          [form]="form"
          [items]="bomItems || []"
          [rows]="formRows"
          [warehouses]="warehouses"
          [locations]="lineLocations"
          [lots]="lineLots"
          [hasLotTracking]="hasLotTracking"
          [rfqActualUom]="rfqActualUom"
          (updateQuantityEvent)="onLineUpdateQuantityEvent($event)"
          (selectLocationEvent)="onLineSelectLocationEvent($event)"
          (selectWarehouseEvent)="onLineSelectWarehouseEvent($event)"
          (createNewLotEvent)="onLineCreateNewLotEvent($event)"
          (searchLotNumberEvent)="onSearchLotNumberEvent($event)"
        ></lum-assembly-order-disassembly-form-table>
      </ng-container>
      <ng-template #loaderLots>
        <mat-progress-spinner
          class="progress-spinner"
          diameter="24"
          mode="indeterminate"
        ></mat-progress-spinner>
        <small>Loading...</small>
      </ng-template>
    </div>

    <ng-container>
      <mat-divider class="my-5"></mat-divider>
      <div class="mt-8">
        <h5>Alternate IDs</h5>
        <div class="form-group">
          <lum-alternate-ids
            [formArray]="alternateIdsFormArray"
            [label]="'Alternate IDs'"
            [placeholder]="'Press enter to add alternate id...'"
          ></lum-alternate-ids>
          </div>
        </div>
    </ng-container>

    <ng-container *ngIf="'utah_FR-553_assembly_order_extra_costs' | featureFlag">
      <mat-divider class="my-5"></mat-divider>
      <div class="mt-8">
        <h5>Extra Costs</h5>
        <lum-extra-costs
          [extraCosts]="extraCosts"
          [form]="form"
          [mode]="currentAssemblyOrder?.id ? 'update' : 'create'"
        ></lum-extra-costs>
      </div>
    </ng-container>
  </div>
</form>
